require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-boiler-house-hunting-for-george.json") })
        }
      }, "path---news-boiler-house-hunting-for-george");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-boiler-house-hunting-for-george!./.cache/json/news-boiler-house-hunting-for-george.json
// module id = 796
// module chunks = 231608221292675